import { ReportPanel } from '@/components/reporting/ReportPanel';
export default function SummaryBuilder() { return <ReportPanel id="insights-summary" showMonths/>; }